export default __webpack_public_path__ + "static/media/banner3.37756a19.jpeg";